export { GetCourseQuery, GetCoursesQuery, GetCourseCollectionQuery } from './queries';
